<section id="natural-stone-lot-list" class="py-3 px-4 md:py-6 md:px-8 relative">
    <div class="mb-2 flex flex-wrap gap-2 md:gap-6">
        <div
            (click)="goBack()"
            class="flex items-center text-primary-default cursor-pointer"
            [attr.gtm-label]="'natural-stone-funnel_link_back-to--natural-stone-catalog'"
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path class="primaryDefault"
                      d="M14.0002 17.3L8.7002 12L14.0002 6.69995L14.7002 7.39995L10.1002 12L14.7002 16.6L14.0002 17.3Z"
                      fill="#232323"></path>
            </svg>
            <div>{{ 'natural_stone.go_back_to_the_catalog' | translate }}</div>
        </div>

        <div class="flex-1"></div>
        <div>
            <app-natural-stone-mini-cart></app-natural-stone-mini-cart>
        </div>
    </div>
    <div class="flex flex-col gap-2 mb-6">
        <div class="flex gap-5 flex-wrap">
            <div class="flex gap-2 flex-wrap items-baseline">
                <span class="font-display font-medium text-2xl">
                    {{getColorText()}}
                </span>
                <span class="typography-body-l-regular">
                    {{getBrandText()}}
                </span>
                <span *ngIf="color().priceGroup" class="typography-body-m-light">
                    {{ 'natural_stone.group' | translate }}&nbsp;{{color().priceGroup}}
                </span>
            </div>
        </div>
    </div>
<!--    Filters-->
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6 mb-6">
        <div class="flex items-center gap-2">
            <p class="m-0 typography-body-m-medium">
                {{'global.finish' | translate}}:
            </p>
            <div class="flex-1 min-w-[120px]">
                <app-select
                    [placeholder]="'select' | translate"
                    [options]="finishOptions"
                    [selectedValue]="selectedFinishValue"
                    [searchable]="false"
                    [isClearable]="false"
                    [disabled]="!areFiltersSelectable"
                    (selectedValueChanged)="changeFinish($event)"
                ></app-select>
            </div>
        </div>

        <div class="flex items-center gap-2">
            <p class="m-0 typography-body-m-medium">
                {{'global.thickness' | translate}}:
            </p>
            <div class="flex-1 min-w-[120px]">
                <app-select
                    [placeholder]="'select' | translate"
                    [options]="thicknessOptions"
                    [selectedValue]="selectedThicknessValue"
                    [searchable]="false"
                    [isClearable]="false"
                    [disabled]="!areFiltersSelectable"
                    (selectedValueChanged)="changeThickness($event)"
                ></app-select>
            </div>
        </div>

        <div class="flex justify-start items-center">
            <span class="typography-body-s-light text-text-tertiary">
                {{'global.showing_x_results' | translate: {varResults: groupedLots().length} }}
            </span>
        </div>

    </div>
    <div class="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-6">
        <app-natural-stone-lot-card
            *ngFor="let lot of groupedLots(); let index = index"
            [lot]="lot"
            [index]="index"
            [thickness]="color().thickness!"
            [finish]="color().finish!"
        ></app-natural-stone-lot-card>
    </div>
</section>
